import { render, staticRenderFns } from "./m-product-detail.vue?vue&type=template&id=5abcfdd4"
import script from "./m-product-detail.vue?vue&type=script&lang=js"
export * from "./m-product-detail.vue?vue&type=script&lang=js"
import style0 from "./m-product-detail.vue?vue&type=style&index=0&id=5abcfdd4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports